import React from "react";
import "./Hero.css";

const CHART_POINTS =
  "0,269.0 6,271.0 13,267.0 19,263.0 26,259.0 32,267.3 39,269.0 45,275.3 51,273.0 58,273.7 64,267.0 71,263.3 77,266.3 84,266.3 90,269.0 96,268.0 103,267.7 109,267.3 116,268.0 122,272.3 129,269.7 135,267.7 141,271.3 148,273.0 154,271.7 161,270.0 167,267.7 174,265.0 180,260.3 186,260.3 193,266.0 199,269.3 206,267.3 212,270.3 219,263.0 225,272.7 232,267.0 238,274.7 244,265.7 251,266.3 257,258.0 264,259.7 270,265.0 276,267.0 283,274.7 289,267.3 296,270.7 302,261.7 309,255.7 315,247.0 322,238.3 328,225.7 334,207.3 341,210.3 347,220.0 354,243.7 360,245.7 367,246.0 373,238.0 379,240.0 386,241.0 392,244.0 399,241.3 405,245.0 412,244.3 418,242.3 424,235.7 431,235.3 437,224.7 444,219.0 450,212.0 457,229.3 463,241.3 470,253.0 476,249.0 482,243.0 489,243.3 495,245.0 502,260.7 508,256.0 515,255.7 521,244.7 527,253.0 534,253.7 540,253.0 547,244.3 553,241.3 559,244.0 566,247.7 572,247.3 579,248.3 585,244.7 591,236.3 598,223.7 605,217.3 611,220.3 617,227.0 624,208.3 630,192.7 637,184.3 643,203.7 650,222.7 656,230.0 662,237.7 669,235.0 675,243.7 682,241.3 688,243.0 694,232.3 701,228.3 707,225.0 714,231.7 720,235.0 727,235.3 733,240.3 740,246.3 746,249.7 752,242.7 759,234.3 765,208.7 772,161.0 778,138.3 785,154.3 791,181.7 797,184.3 804,181.3 810,193.3 817,200.7 823,203.0 830,201.7 836,200.7 842,171.7 849,132.7 855,124.3 862,135.3 868,147.7 875,141.0 881,156.3 888,182.3 894,202.3 900,208.3 907,201.0 913,176.3 920,157.3 926,151.7 933,159.7 939,159.3";

export default function Hero() {
  return (
    <main id="top" className="content-inner">
      <section className="hero-section">
        <div className="hero" data-hero="1">

          {/* CHART */}
          <div className="hero-chart" data-herochart="1">
            <div className="hero-chart-glow" />

            <div className="hero-chart-card">

              <div className="hero-chart-header">
                <div className="hero-chart-title">
                  <span className="hero-pulse-dot" />
                  <span>EPU Index PL · daily</span>
                </div>

                <span className="hero-chart-period">
                  2000 – 2026
                </span>
              </div>

              <div
                className="hero-svg-wrapper"
                data-herosvg="1"
              >
                <svg
                  viewBox="0 0 1000 300"
                  preserveAspectRatio="none"
                  className="hero-svg"
                  aria-label="EPU Index Poland, January 2000 to today"
                >
                  <defs>
                    <linearGradient
                      id="epuFill"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop
                        offset="0%"
                        stopColor="#EF3A5D"
                        stopOpacity=".28"
                      />
                      <stop
                        offset="100%"
                        stopColor="#EF3A5D"
                        stopOpacity="0"
                      />
                    </linearGradient>
                  </defs>

                  {/* Grid lines */}
                  <line
                    x1="0"
                    y1="110"
                    x2="1000"
                    y2="110"
                    stroke="#ffffff"
                    strokeWidth="1"
                    opacity=".07"
                    vectorEffect="non-scaling-stroke"
                  />

                  <line
                    x1="0"
                    y1="180"
                    x2="1000"
                    y2="180"
                    stroke="#ffffff"
                    strokeWidth="1"
                    opacity=".07"
                    vectorEffect="non-scaling-stroke"
                  />

                  <line
                    x1="0"
                    y1="250"
                    x2="1000"
                    y2="250"
                    stroke="#7E93A6"
                    strokeWidth="1"
                    strokeDasharray="2 6"
                    opacity=".45"
                    vectorEffect="non-scaling-stroke"
                  />

                  {/* Area */}
                  <polygon
                    fill="url(#epuFill)"
                    points={`${CHART_POINTS} 939,300 0,300`}
                    className="hero-chart-fill"
                  />

                  {/* Line */}
                  <polyline
                    fill="none"
                    stroke="#EF3A5D"
                    strokeWidth="2"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    vectorEffect="non-scaling-stroke"
                    points={CHART_POINTS}
                    className="hero-chart-line"
                  />
                </svg>

                {/* Current value marker */}
                <div className="hero-current-point">
                  <span className="hero-current-pulse" />
                  <span className="hero-current-dot" />
                </div>

                {/* 100 baseline label */}
                <div className="hero-baseline">
                  100
                </div>
              </div>

              <div className="hero-chart-years">
                <span>2000</span>
                <span>2008</span>
                <span>2016</span>
                <span>2026</span>
              </div>

            </div>
          </div>

          {/* TEXT */}
          <div className="hero-copy">
            <h1>
              Poland&apos;s policy uncertainty has a number<span style={{ color: "#EF3A5D" }}>.</span>&nbsp;
            </h1>

            <p>
              Every morning we scan Poland&apos;s six national dailies and measure what share of their coverage 
              concerns uncertainty over economic policy. That share becomes one number, tracked since January 2000. 
              The monthly series is open to everyone.
            </p>
          </div>

          {/* BUTTONS */}
          <div className="hero-actions">

            <a
              href="/data"
              className="hero-button hero-button-primary"
            >
              See the data
              <span className="hero-button-arrow">›</span>
            </a>

            <a
              href="#series"
              className="hero-button hero-button-secondary"
            >
              Explore the series
            </a>

          </div>

        </div>
      </section>
    </main>
  );
}